import axios from 'axios';
import CustomError from '../utils/customError';
import parseConfirmationData from '../utils/parseConfirmationData';
import { updateDataEndpoint } from './endpoints';

const postConfirmData = async (confirmationData, id, setError, authorized) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${authorized.jwt.access_token}`
      }
    };
    const newData = parseConfirmationData(confirmationData, id);
    const response = await axios.put(updateDataEndpoint(id), newData, config);

    if (parseInt(response.status) !== 200 || !response) {
      throw new CustomError({
        type: 'PUT ERROR',
        message: 'Error al actualizar y/o confirmar los datos del cliente.',
      });
    }

    return response;
  } catch (error) {
    setError(error);
  }
};

export default postConfirmData;
